<template>
	<!-- <el-submenu v-if="menu.list && menu.list.length >= 1" :index="menu.menuId + ''"
		:popper-class="'site-sidebar--' + sidebarLayoutSkin + '-popper'">
		<template slot="title">
			<span>{{ menu.name}}</span>
		</template>
		<sub-menu v-for="item in menu.list" :key="item.menuId" :menu="item" :dynamicMenuRoutes="dynamicMenuRoutes">
		</sub-menu>
	</el-submenu> -->
	<!--  -->
	<el-menu-item v-else class="haha" :index="menu.menuId + ''" @click="gotoRouteHandle(menu)">
		<!--  <icon-svg :name="menu.icon || ''" class="site-sidebar__menu-icon"></icon-svg> -->
		<span>{{ $t(menu.key) }}</span>
	</el-menu-item>
</template>

<script>
	import SubMenu from "./sub-menu";
	export default {
		name: "sub-menu",
		props: {
			menu: {
				type: Object,
				required: true,
			},
			dynamicMenuRoutes: {
				type: Array,
				required: true,
			},
		},
		components: {
			SubMenu,
		},
		watch: {
			$route(newValue, oldValue) {
				// console.log('111',newValue)
			}
		},
		computed: {
			sidebarLayoutSkin: {
				get() {
					return this.$store.state.common.sidebarLayoutSkin;
				},
			},
		},
		methods: {
			// 通过menuId与动态(菜单)路由进行匹配跳转至指定路由
			gotoRouteHandle(menu) {
				console.log(this.$router)
				this.$router.push({
					name: menu.url,
				});
			},
		},
	};
</script>